<template>
  <ERow no-gutters class="measuring__controls px-4 py-2" justify="between">
    <ERow
      justify="center"
      :class="{ 'px-3': !bimTransparencyStore.isEditMode }"
    >
      <div class="mr-3">
        <ButtonTooltip
          v-if="bimTransparencyStore.isEditMode"
          small
          :tooltip-props="{ 'nudge-bottom': 8 }"
          tooltip-text="Save"
          icon-name="fa-save"
          @mousedown="updateMask"
        />
      </div>

      <!-- Select mode -->

      <ButtonTooltip
        v-if="bimTransparencyStore.isEditMode"
        button-class="mr-3"
        small
        :color="bimTransparencyStore.isSelecting ? 'primary' : 'default'"
        icon-name="fas fa-mouse-pointer"
        tooltip-text="Select"
        @mousedown="
          bimTransparencyStore.isSelecting = !bimTransparencyStore.isSelecting
        "
      />

      <!-- Delete -->

      <ButtonTooltip
        v-if="bimTransparencyStore.isEditMode"
        button-class="mr-3"
        small
        :disabled="deleteBtnDisabled"
        :tooltip-props="{ 'nudge-bottom': 8, disabled: deleteBtnDisabled }"
        icon-name="fas fa-trash-alt"
        tooltip-text="Delete"
        @mousedown="bimTransparencyStore.deleteSelectedShape"
      />

      <!-- Edit mode toggle -->

      <div :class="bimTransparencyStore.isEditMode ? undefined : 'w-100'">
        <ButtonTooltip
          small
          :block="!bimTransparencyStore.isEditMode"
          :icon-name="`fas fa-${
            bimTransparencyStore.isEditMode ? 'times' : 'layer-group'
          }`"
          :tooltip-text="
            bimTransparencyStore.isEditMode ? 'Close' : 'Open tool'
          "
          :tooltip-props="{
            'nudge-bottom': bimTransparencyStore.isEditMode ? '8' : '',
          }"
          @mousedown="toggleEditMode"
        />
      </div>
    </ERow>
  </ERow>
</template>

<script>
import LAYER_TYPES from "@evercam/shared/constants/layerTypes"
import { EvercamApi } from "@evercam/shared/api/evercamApi"
import { mapStores } from "pinia"
import { useBimTransparencyStore } from "@/stores/bimTransparency"
import { useCameraDialogStore } from "@/stores/cameraDialog"
import ButtonTooltip from "@evercam/shared/components/ButtonTooltip"

export default {
  name: "BIMTransparencyToolBar",
  components: { ButtonTooltip },
  computed: {
    ...mapStores(useBimTransparencyStore, useCameraDialogStore),
    deleteBtnDisabled() {
      return (
        this.bimTransparencyStore.selectedShapeIndex === Infinity ||
        !this.bimTransparencyStore.shapes.length
      )
    },
  },
  methods: {
    toggleEditMode() {
      this.bimTransparencyStore.isEditMode =
        !this.bimTransparencyStore.isEditMode
    },
    updateMask() {
      EvercamApi.layers
        .createLayer(this.cameraDialogStore.camera?.exid, {
          name: this.cameraDialogStore.camera?.exid + " BIM Mask",
          startAt: new Date().toISOString(),
          layerType: LAYER_TYPES.BIM_MASK,
          apiKey: this.cameraDialogStore.camera?.userApiKey,
          apiId: this.cameraDialogStore.camera?.userApiId,
          shapes: JSON.stringify(this.bimTransparencyStore.shapes),
        })
        .then(() => {
          this.$notifications.success("Mask updated successfully.")
        })
        .catch((error) => {
          this.$notifications.error({ text: "Updating mask failed!", error })
        })
    },
  },
}
</script>
